import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import {
  TextInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { columnnames } from "variables/backoffice/realestate";
import { categoryData, entitytypeData, datatypeData } from "variables/backoffice/lists/realestate";
import { postBackOfficeRealestate } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function CreateVariableDialog(props) {
  const [category, setCategory] = useState("");
  const [request, setRequest] = useState("");
  const [path, setPath] = useState("");
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [entitytype, setEntitytype] = useState([]);
  const [datatype, setDatatype] = useState("");
  const [data, setData] = useState("");
  const [description, setDescription] = useState("");


  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      category.length > 0 &&
      id.length > 0 &&
      name.length > 0 &&
      entitytype.length > 0 &&
      datatype.length > 0 &&
      description.length > 0 
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name,category,id,entitytype,datatype,description]);


  const handleSubmit = async (event) => {
    createVariable(event);
  };

  const handleCategoryChange = (event) => { 
    setRequest(categoryData.find((x) => x.id == event.target.value)?.request);
    setPath(categoryData.find((x) => x.id == event.target.value)?.path);
    setCategory(event.target.value); 
  };
  const handleIdChange = (event) => { setId(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleEntitytypeChange = (event) => {setEntitytype(event.target.value); };
  const handleDatatypeChange = (event) => { setDatatype(event.target.value); };
  const handleDataChange = (event) => { setData(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };



  let url = postBackOfficeRealestate();
  const createVariable = async (event) => {
    await axios
      .post(
        url,
        {
          category,
          request,
          path,
          id,
          name,
          entitytype,
          datatype,
          data,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Variable créée");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={columnnames.category}
                selectValue={category}
                handleSelectValueChange={handleCategoryChange}
                data={categoryData}
              />
            </div>
            <div>
              <TextInput
                disabled
                inputTitle={columnnames.request}
                textInput={request}
              />
            </div>
            <div>
              <TextInput
                disabled
                inputTitle={columnnames.path}
                textInput={path}
              />
            </div>
            <div>
              <TextInput
                inputTitle={columnnames.id}
                textInput={id}
                handleTextInputChange={handleIdChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={columnnames.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <CustomSelect
                multiple
                inputTitle={columnnames.entitytype}
                selectValue={entitytype}
                handleSelectValueChange={handleEntitytypeChange}
                data={entitytypeData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={columnnames.datatype}
                selectValue={datatype}
                handleSelectValueChange={handleDatatypeChange}
                data={datatypeData}
              />
            </div>
            <div>
              <TextInput
                inputTitle={columnnames.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Créer
            </Button>
          </GridItem>

        </GridContainer>
      </form>
    </>
  );
}

export default CreateVariableDialog;
